import { useState } from 'react';

const testimonials = [
  {
    quote: 'After Hurricane Harvey hit our neighborhood, PRA Roof Contractors was on-site within 48 hours. They handled everything — the inspection, the insurance adjuster meeting, and the full replacement. Our roof was done in two days and the crew left the yard spotless. Absolutely professional from start to finish.',
    name: 'Michael R.',
    location: 'Houston, TX',
    service: 'Storm Damage Restoration',
    rating: 5,
  },
  {
    quote: 'I was dreading the insurance claim process after hail damage, but PRA made it completely painless. Their team knew exactly what documentation the adjuster needed and we got full coverage approved. The installation crew was fast, clean, and respectful of our property. Highly recommend.',
    name: 'Sandra T.',
    location: 'Baton Rouge, LA',
    service: 'Hail Damage Repair',
    rating: 5,
  },
  {
    quote: 'PRA replaced our entire commercial roof in Lafayette and the project was completed ahead of schedule. The project manager kept us updated every single day. The quality of materials and workmanship is outstanding — you can tell these guys take real pride in their work.',
    name: 'James L.',
    location: 'Lafayette, LA',
    service: 'Commercial Roof Replacement',
    rating: 5,
  },
  {
    quote: 'We\'ve used PRA twice now — once for a repair and once for a full replacement. Both times the communication was excellent, the crews were professional, and the cleanup was immaculate. They\'re the only roofing company I\'ll ever call in Charlotte.',
    name: 'Patricia M.',
    location: 'Charlotte, NC',
    service: 'Roof Replacement',
    rating: 5,
  },
  {
    quote: 'From the initial inspection to the final walkthrough, PRA was exceptional. They identified damage I didn\'t even know existed, coordinated with my insurance company, and completed the job faster than I expected. The new roof looks incredible and I feel so much better protected.',
    name: 'David K.',
    location: 'Katy, TX',
    service: 'Full Roof Replacement',
    rating: 5,
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-[#c0392b] text-xs font-bold tracking-widest uppercase mb-3 block">Client Stories</span>
          <h2 className="text-4xl md:text-5xl font-black text-[#1a1a1a] leading-tight">
            What Our Customers Say
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="bg-[#1a1a1a] rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left Image */}
            <div className="lg:w-2/5 relative">
              <img
                src="https://public.readdy.ai/ai/img_res/2f9f50cff258ce15b1dd09979f67548f.jpg"
                alt="Satisfied PRA Roof Contractors customer"
                className="w-full h-64 lg:h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1a1a1a]/30 hidden lg:block"></div>
            </div>

            {/* Right Content */}
            <div className="lg:w-3/5 p-8 md:p-12 flex flex-col justify-between">
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#c0392b] text-lg"></i>
                ))}
              </div>

              {/* Quote Mark */}
              <div className="text-white/10 text-8xl font-black leading-none mb-2 select-none">"</div>

              {/* Quote */}
              <blockquote className="text-white/85 text-base md:text-lg leading-relaxed mb-8 -mt-6">
                {t.quote}
              </blockquote>

              {/* Signature */}
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <p className="text-white font-bold text-base">{t.name}</p>
                  <p className="text-white/50 text-sm">{t.location} · {t.service}</p>
                </div>

                {/* Navigation */}
                <div className="flex items-center gap-3">
                  <button
                    onClick={prev}
                    className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#c0392b] rounded-full transition-colors duration-200 cursor-pointer"
                    aria-label="Previous testimonial"
                  >
                    <i className="ri-arrow-left-line text-white text-sm"></i>
                  </button>
                  <span className="text-white/40 text-xs">{current + 1} / {testimonials.length}</span>
                  <button
                    onClick={next}
                    className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#c0392b] rounded-full transition-colors duration-200 cursor-pointer"
                    aria-label="Next testimonial"
                  >
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-[#c0392b] hover:bg-[#a93226] text-white font-bold px-10 py-4 rounded-full text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line"></i>
            Request a Free Inspection
          </a>
        </div>
      </div>
    </section>
  );
}
